import "./i18n";
import { REPORTS_LIST as BASE_REPORTS_LIST, REPORTS_CREATE as BASE_REPORTS_CREATE, REPORTS_EDIT as BASE_REPORTS_EDIT, REPORTS_VIEW as BASE_REPORTS_VIEW, } from "./config/routes";
export const REPORTS_LIST = {
    ...BASE_REPORTS_LIST,
};
export const REPORTS_CREATE = {
    ...BASE_REPORTS_CREATE,
};
export const REPORTS_EDIT = {
    ...BASE_REPORTS_EDIT,
};
export const REPORTS_VIEW = {
    ...BASE_REPORTS_VIEW,
};
